import styled from 'styled-components/native';
import { MaterialCommunityIcons } from '@expo/vector-icons'; 

export const Barcode = styled(MaterialCommunityIcons).attrs({
	name: "barcode-scan",
  size: 25,
  color: "white"
})`
`;
